const isHomolog = host => !!host.match(/localhost|dev|hom|qa|preprod/g)

export default isHomolog
